<div class="container notifications-page-container">
  <app-general-header title="Notifications"></app-general-header>
  <div class="card border-0 p-3 notifications-card">
    <div class="row">
      <div class="col-12 col-md-3 mb-3 mb-md-0">
        <ul
          class="nav flex-column notifications-filter-nav d-none d-md-flex"
          role="tablist">
          <li *ngFor="let filter of filters" class="nav-item">
            <button
              type="button"
              role="tab"
              class="nav-link notifications-filter-link"
              [class.active]="activeFilter === filter.key"
              (click)="setFilter(filter.key)">
              {{ filter.label }}
            </button>
          </li>
        </ul>

        <!-- MOBILE NAV -->
        <div
          class="custom-select d-md-none"
          [class.open]="customCollapsed"
          (click)="toggleCustomCollapsed()">
          <div class="custom-select__trigger">
            <div>{{ selectedFilterLabel }}</div>
            <i *ngIf="!customCollapsed" class="bi bi-caret-up-fill"></i>
            <i *ngIf="customCollapsed" class="bi bi-caret-down-fill"></i>
          </div>
          <ul class="custom-options">
            <li
              *ngFor="let filter of filters"
              [class.active]="activeFilter === filter.key"
              (click)="setFilter(filter.key); $event.stopPropagation()"
              class="custom-option">
              {{ filter.label }}
            </li>
          </ul>
        </div>
      </div>

      <div class="col-12 col-md-9">
        <ng-container *ngIf="notifications; else isLoading">
          <div *ngIf="notifications.length < 1" class="text-center py-5 mt-5">
            <h2>No Notifications</h2>
            <p>You don't have any notifications in this category yet.</p>
          </div>

          <a
            *ngFor="let notification of notifications"
            href="javascript:void(0)"
            (click)="goToNotificationSource(notification)"
            class="notification-list-row d-flex align-items-start"
            [class.unread]="!notification.date_shown">
            <div class="avatar-with-badge position-relative">
              <div
                class="avatar-ring"
                [style.border-color]="
                  typeMeta[notification.notification_type]?.color
                ">
                <app-avatar
                  avatarSize="medium-large"
                  [showBorder]="false"
                  [profileLinkActive]="!!notification.actorUser"
                  [hideTooltip]="!notification.actorUser"
                  [profile]="notification.actorUser?.profile || null"
                  [avatarData]="getActorAvatarData(notification)" />
              </div>
              <span
                class="type-badge"
                [style.background-color]="
                  typeMeta[notification.notification_type]?.color
                ">
                <i
                  class="bi bi-{{
                    typeMeta[notification.notification_type]?.icon
                  }}"></i>
              </span>
            </div>
            <div class="notification-content ms-3 flex-grow-1">
              <div class="d-flex justify-content-between align-items-baseline">
                <div class="fw-bold notification-title">
                  {{ notificationTitle(notification) }}
                </div>
                <div class="notification-time text-muted fs-11">
                  {{
                    notification.notification_date | formatDistanceToNow : true
                  }}
                </div>
              </div>
              <div class="notification-message">
                {{ notification.notification_message }}
              </div>
            </div>
          </a>

          <div
            *ngIf="listMeta && listMeta.totalCount > pageSize"
            class="row mt-4">
            <div class="d-flex justify-content-center">
              <ngb-pagination
                [(page)]="listMeta.currentPage"
                [pageSize]="pageSize"
                [collectionSize]="listMeta.totalCount"
                (pageChange)="fetchNotifications()"
                [maxSize]="5"
                [ellipses]="true"></ngb-pagination>
            </div>
          </div>
        </ng-container>
        <ng-template #isLoading>
          <div class="w-100" style="background-color: #fff; height: 400px">
            <app-loader></app-loader>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
